import { useLanguage } from '../../i18n/LanguageContext';

interface StepSidebarProps {
  currentStep: number;
  completedSteps: number[];
}

export default function StepSidebar({ currentStep, completedSteps }: StepSidebarProps) {
  const { t } = useLanguage();

  const steps = [
    { number: 1, label: t('onboarding.step.licenseAndId') },
    { number: 2, label: t('onboarding.step.garageInfo') },
    { number: 3, label: t('onboarding.step.terms') || 'Agreements' },
  ];

  return (
    <div className="stepper">
      {steps.map((step, index) => {
        const isCompleted = completedSteps.includes(step.number);
        const isActive = currentStep === step.number;
        const status = isCompleted ? 'completed' : isActive ? 'active' : 'pending';

        return (
          <div key={step.number}>
            <div className={`stepper-step ${status}`}>
              <div className="stepper-indicator">
                <div className="stepper-circle">
                  {isCompleted ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                  ) : (
                    step.number
                  )}
                </div>
              </div>
              <div className="stepper-label">
                <h3>{step.label}</h3>
              </div>
            </div>
            {index < steps.length - 1 && !isActive && (
              <div className="stepper-divider" />
            )}
          </div>
        );
      })}
    </div>
  );
}
